import { OneSecondInMillis } from '@racemap/utilities/consts/time';
import { type FC, useRef } from 'react';
import { getCurrentEvents, reduceEndTime, reduceMax } from '../selectors';
import { useStore } from '../store';
import { correctedNow } from '../utils/clock';
import { useInterval } from '../utils/hooks';

interface Props {
  interval: number;
}

export const Timer: FC<Props> = ({ interval }) => {
  const actions = useStore((state) => state.actions);
  const endTime = useStore((state) => reduceEndTime(getCurrentEvents(state)));
  const isLive = useStore((state) => state.timer.isLive);
  const liveDelay = useStore((state) =>
    reduceMax(getCurrentEvents(state), (ev) => ev.options.liveDelay),
  );

  const lastTime = useRef(0);

  function handleTick() {
    const now = correctedNow();
    if (isLive) {
      const time = now - liveDelay;
      if (time < endTime) {
        actions.setTimerTime(time);
      } else {
        actions.pauseTimer();
        actions.setIsLive(false);
      }
    } else {
      if (lastTime.current === 0) {
        // pass
      } else {
        const timeDiff = Math.min(OneSecondInMillis, now - lastTime.current);
        actions.forwardTimerTime(timeDiff);
      }
    }
    lastTime.current = now;
  }

  useInterval(handleTick, interval);

  return null;
};
